import { PDF_PAGES_TOKEN, PDF_PAGE_FOOTER_STYLE, PDF_PAGE_MARGIN, PDF_PAGE_TOKEN } from "consts";

/** Turns translated copy holding the page tokens into a CSS `content` value. */
const toPageCounterContent = (label: string): string =>
  label
    .split(new RegExp(`(${PDF_PAGE_TOKEN}|${PDF_PAGES_TOKEN})`))
    .filter(Boolean)
    .map((part) => (part === PDF_PAGE_TOKEN ? "counter(page)" : part === PDF_PAGES_TOKEN ? "counter(pages)" : JSON.stringify(part)))
    .join(" ");

/** The report's @page rule: landscape A4, brand bottom-left, page counter bottom-right, and an empty top box to suppress Chrome's header. */
export const buildPdfPageStyle = (footerBrand: string, pageCounterLabel: string): string => `
      @page {
        size: a4 landscape;
        margin: ${PDF_PAGE_MARGIN};
        @top-left { content: ""; }
        @bottom-left { content: ${JSON.stringify(footerBrand)}; ${PDF_PAGE_FOOTER_STYLE} }
        @bottom-right { content: ${toPageCounterContent(pageCounterLabel)}; ${PDF_PAGE_FOOTER_STYLE} }
      }
    `;
